import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { encryptionDetailLive } from "@/api/php/player";
import { useRoute } from "vue-router";
import { DataUtils } from "@/model/DataUtils";
import { storeToRefs } from "pinia"
import { serverConfigPiniaState } from "@/store/serverConfig";
import { toLocationBrowser } from "@/uitls/native";
import { useI18n } from 'vue-i18n'
interface dataProps {
  roomdata: any;
}

const __default__ = {
  name: "Football",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    roomdata: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  roomdata: any;
}

_useCssVars(_ctx => ({
  "3188e0ca-primaryColor": (_unref(primaryColor))
}))

const { t } = useI18n()
const ConfigpiniaStore = serverConfigPiniaState();
const { matchAD } = storeToRefs(ConfigpiniaStore);

const route = useRoute();
const ICON1 = require("@/assets/images/huangpai.png");
const ICON2 = require("@/assets/images/hongpai.png");
const ICON3 = require("@/assets/images/jiaoqiu.png");
const ICON4 = require("@/assets/images/jinqiu.png");
const ICON5 = require("@/assets/images/dianqiu.png");
const ICON6 = require("@/assets/images/huanren.png");
const ICON7 = require("@/assets/images/lianghuanyihong.png");
const ICON8 = require("@/assets/images/dianqiuweijin.png");
const ICON9 = require("@/assets/images/wulong.png");
const ICON10 = require("@/assets/images/zhugong.png");

let data = ref();
let atackHome = ref(0);
let atackAway = ref(0);
let atackallscr = ref(0);
let dangerousatackHome = ref(0);
let dangerousatackAway = ref(0);
let dangscr = ref(0);
let ballPossessionHome = ref(0);
let ballPossessionAway = ref(0);
let ballPosscr = ref(0);
let team1 = ref("");
let team2 = ref("");
let huangPaiHome = ref(0);
let huangPaiAway = ref(0);
let hongPaiHome = ref(0);
let hongPaiAway = ref(0);
let jiaoqiuHome = ref(0);
let jiaoqiuAway = ref(0);
let shengzhenHome = ref(0);
let shengzhenAway = ref(0);
let shengPianHome = ref(0);
let shengPianAway = ref(0);
let liveSheZhengHome = ref("0");
let liveSheZhengAway = ref("0");
let liveShePianHome = ref("0");
let liveShePianAway = ref("0");
let statistics = ref(false);
let statsall = ref([]);
let tlive = ref([]);
let incidents = ref([]);
let detailsshow = ref(true);

const ICONS_NAME_DATA = [
  { icon: ICON4, name: t('match.matchjq') },
  { icon: ICON5, name: t('match.matchdq') },
  { icon: ICON8, name: t('match.matchdqwj') },
  { icon: ICON9, name: t('me.wl') },
  { icon: ICON10, name: t('match.matchzg1') },
  { icon: ICON3, name: t('match.matchjqs') },
  { icon: ICON1, name: t('match.matchhp2') },
  { icon: ICON2, name: t('match.matchhp') },
  { icon: ICON6, name: t('match.matchhr') },
  { icon: ICON7, name: t('me.lhyh') },
];



onMounted(() => {
  getData();
  teamname();
});

const getData = async () => {
  let { matchType, matchId } = route.query;

  if (
    matchId == "" ||
    matchId == null ||
    matchId == undefined ||
    matchId == "0"
  ) {
    if(props.roomdata.match_id){
      matchId = props.roomdata.match_id;
    }else{
       matchId = props.roomdata.id;
    }
  }
  if (
    matchType == "" ||
    matchType == null ||
    matchType == undefined ||
    matchType == "0"
  ) {
    if (props.roomdata.type_id) {
      matchType = props.roomdata.type_id
    } else {
      matchType = props.roomdata.match_type;
    }
  }

  if (
    matchType != "" &&
    matchType != null &&
    matchType != undefined &&
    matchId != "" &&
    matchId != null &&
    matchId != undefined
  ) {
    //   赛况数据
    const res: any = await encryptionDetailLive({
      type_id: matchType,
      match_id: matchId,
    });


    if (res.code == 200 && res.data) {
      data.value = res.data;

      let statsMap = [];
      let stats = res.data.stats;
      if (stats) {
        for (let i = 0; i < stats.length; i++) {
          statsMap[stats[i].type] = stats[i];
        }
        serdatas(statsMap);
      }

      if (res.data && res.data.tlive) {
        // 文字直播，倒序输出
        tlive.value = res.data.tlive.reverse();
      }
      if (res.data && res.data.incidents) {
        // 重要事件
        incidents.value = res.data.incidents.reverse();
      }
    }
  }
};
const serdatas = (stats) => {
  // 渲染的统计数据
  statsall.value = stats;

  // 进攻
  atackHome.value = stats[23] && stats[23].home ? stats[23].home : 0;
  atackAway.value = stats[23] && stats[23].away ? stats[23].away : 0;
  // 危险进攻
  dangerousatackHome.value = stats[24] && stats[24].home ? stats[24].home : 0;
  dangerousatackAway.value = stats[24] && stats[24].away ? stats[24].away : 0;
  // 控球率
  ballPossessionHome.value = stats[25] && stats[25].home ? stats[25].home : 0;
  ballPossessionAway.value = stats[25] && stats[25].away ? stats[25].away : 0;

  // 黄牌,红牌,角球
  huangPaiHome.value = stats[3] && stats[3].home ? stats[3].home : 0;
  huangPaiAway.value = stats[3] && stats[3].away ? stats[3].away : 0;
  hongPaiHome.value = stats[4] && stats[4].home ? stats[4].home : 0;
  hongPaiAway.value = stats[4] && stats[4].away ? stats[4].away : 0;
  jiaoqiuHome.value = stats[2] && stats[2].home ? stats[2].home : 0;
  jiaoqiuAway.value = stats[2] && stats[2].away ? stats[2].away : 0;

  // 射正球门，射偏球门
  shengzhenHome.value = stats[21] && stats[21].home ? stats[21].home : 0;
  shengzhenAway.value = stats[21] && stats[21].away ? stats[21].away : 0;
  shengPianHome.value = stats[22] && stats[22].home ? stats[22].home : 0;
  shengPianAway.value = stats[22] && stats[22].away ? stats[22].away : 0;

  // 射正球门，射偏球门  计算百分比
  liveSheZhengHome.value =
    shengzhenHome.value + shengzhenAway.value == 0
      ? "0"
      : (
        shengzhenHome.value /
        (shengzhenHome.value + shengzhenAway.value)
      ).toFixed(2);
  liveSheZhengAway.value =
    shengzhenHome.value + shengzhenAway.value == 0
      ? "0"
      : (
        shengzhenAway.value /
        (shengzhenHome.value + shengzhenAway.value)
      ).toFixed(2);

  liveShePianHome.value =
    shengPianHome.value + shengPianAway.value == 0
      ? "0"
      : (
        shengPianHome.value /
        (shengPianHome.value + shengPianAway.value)
      ).toFixed(2);
  liveShePianAway.value =
    shengPianHome.value + shengPianAway.value == 0
      ? "0"
      : (
        shengPianAway.value /
        (shengPianHome.value + shengPianAway.value)
      ).toFixed(2);

  // 环形进度条 计算百分比
  atackallscr.value = getPercent(atackHome.value, atackAway.value);
  dangscr.value = getPercent(
    dangerousatackHome.value,
    dangerousatackAway.value
  );
  ballPosscr.value = getPercent(
    ballPossessionHome.value,
    ballPossessionAway.value
  );
};

const getPercent = (score1, score2) => {
  // 计算两个整数之间的百分比 (环形进度条，全部统计)
  let lv = score1 + score2 == 0 ? 0 : (score2 / (score1 + score2)) * 100;
  return lv;
};

const teamname = async () => {
  // 队伍名称1
  if (
    props.roomdata &&
    props.roomdata.home_name != "" &&
    props.roomdata.home_name != null &&
    props.roomdata.home_name != undefined
  ) {
    team1.value = props.roomdata.home_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team1.value = arr[0];
  }
  // 队伍名称2
  if (
    props.roomdata &&
    props.roomdata.away_name != "" &&
    props.roomdata.away_name != null &&
    props.roomdata.away_name != undefined
  ) {
    team2.value = props.roomdata.away_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team2.value = arr[1];
  }
};
// 图标
const getIcon = (type) => {
  switch (type) {
    case 1:
      return ICON4;
    case 2:
      return ICON3;
    case 3:
      return ICON1;
    case 4:
      return ICON2;
    case 8:
      return ICON5;
    case 9:
      return ICON6;
    case 15:
      return ICON7;
    case 16:
      return ICON8;
    case 17:
      return ICON9;
  }
};
const getColor = (postion) => {
  // 文字直播队伍颜色
  if (postion == 1) {
    return "#FC2E34";
  } else if (postion == 2) {
    return "#368BF4";
  }
  return "transparent";
};
const majortype = (type) => {
  // 重要事件类型
  if (
    type == 1 ||
    type == 2 ||
    type == 3 ||
    type == 4 ||
    type == 15 ||
    type == 16 ||
    type == 17
  ) {
    return 1;
  } else if (type == 9) {
    return 2;
  } else {
    return 3;
  }
};
const th = process.env.VUE_APP_Language as string;
const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;

const __returned__ = { t, ConfigpiniaStore, matchAD, route, ICON1, ICON2, ICON3, ICON4, ICON5, ICON6, ICON7, ICON8, ICON9, ICON10, data, atackHome, atackAway, atackallscr, dangerousatackHome, dangerousatackAway, dangscr, ballPossessionHome, ballPossessionAway, ballPosscr, team1, team2, huangPaiHome, huangPaiAway, hongPaiHome, hongPaiAway, jiaoqiuHome, jiaoqiuAway, shengzhenHome, shengzhenAway, shengPianHome, shengPianAway, liveSheZhengHome, liveSheZhengAway, liveShePianHome, liveShePianAway, statistics, statsall, tlive, incidents, detailsshow, ICONS_NAME_DATA, props, getData, serdatas, getPercent, teamname, getIcon, getColor, majortype, th, primaryColor, DataUtils, toLocationBrowser }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})